"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rbIconPack = {
    prefix: 'rb_',
    cdnSuffix: 'rb',
    version: 'latest',
    icons: {
        artist: 'artist.svg',
        card_type_battlefield: 'card_type_battlefield.svg',
        card_type_gear: 'card_type_gear.svg',
        card_type_legend: 'card_type_legend.svg',
        card_type_rune: 'card_type_rune.svg',
        card_type_spell: 'card_type_spell.svg',
        card_type_unit: 'card_type_unit.svg',
        champion: 'champion.svg',
        colorless: 'colorless.svg',
        energy_0: 'energy_0.svg',
        energy_1: 'energy_1.svg',
        energy_2: 'energy_2.svg',
        energy_3: 'energy_3.svg',
        energy_4: 'energy_4.svg',
        energy_5: 'energy_5.svg',
        energy_6: 'energy_6.svg',
        energy_7: 'energy_7.svg',
        energy_8: 'energy_8.svg',
        energy_9: 'energy_9.svg',
        energy_10: 'energy_10.svg',
        energy_11: 'energy_11.svg',
        energy_12: 'energy_12.svg',
        exhaust: 'exhaust.svg',
        might: 'might.svg',
        rarity_common: 'rarity_common.png',
        rarity_epic: 'rarity_epic.png',
        rarity_overnumbered: 'rarity_overnumbered.png',
        rarity_rare: 'rarity_rare.png',
        rarity_uncommon: 'rarity_uncommon.png',
        rune_body: 'rune_body.svg',
        rune_calm: 'rune_calm.svg',
        rune_chaos: 'rune_chaos.svg',
        rune_fury: 'rune_fury.svg',
        rune_mind: 'rune_mind.svg',
        rune_order: 'rune_order.svg',
        rune_rainbow: 'rune_rainbow.svg',
    },
};
exports.default = rbIconPack;
